import InputMask from "react-input-mask";
import { Form } from "react-bootstrap";

export default function CustomInput(props) {
    const {disabled, mask, value, onChange} = props;
    return (
        
        <InputMask
            className={disabled}
            mask={mask}
            value={value}
            onChange={onChange}
            disabled={disabled == "true" ? true: false}
        >
            {(inputProps,disabled) => 
                <Form.Control {...inputProps} disabled={disabled} fullWidth />
            }
        </InputMask>
    )
}